import { render, staticRenderFns } from "./contact-table.vue?vue&type=template&id=7270171f&scoped=true&"
import script from "./contact-table.ts?vue&type=script&lang=ts&"
export * from "./contact-table.ts?vue&type=script&lang=ts&"
import style0 from "./contact-table.scss?vue&type=style&index=0&id=7270171f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7270171f",
  null
  
)

export default component.exports